// Follow Overview's established visual scale without changing its header.
export const reportHeaderSx = {
  px: { xs: 1.25, sm: 1.75, md: 2 },
  py: { xs: 1.25, sm: 1.5, md: 1.75 },
  bgcolor: '#fff',
  borderRadius: { xs: '14px', sm: '16px' },
  border: '1px solid rgba(15, 23, 42, 0.06)',
  boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
};

export const reportTitleSx = {
  fontWeight: 800,
  fontSize: { xs: '1rem', sm: '1.15rem', md: '1.35rem' },
  lineHeight: 1.2,
  color: '#020617',
};

export const reportSectionTitleSx = {
  fontWeight: 800,
  fontSize: '1.05rem',
  lineHeight: 1.3,
  color: '#111827',
};

export const reportBodySx = {
  fontSize: { xs: '0.76rem', sm: '0.8rem' },
  lineHeight: 1.4,
  color: '#475569',
};

export const reportActionSx = {
  minHeight: { xs: 44, sm: 32 },
  minWidth: { xs: 44, sm: 'auto' },
  px: { xs: 0.65, sm: 1 },
  py: { xs: 0.35, sm: 0.4 },
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '0.72rem',
  whiteSpace: 'nowrap',
};

// Report content needs its own light surface on the dashboard's dark canvas.
export const reportPanelSx = {
  minWidth: 0,
  p: { xs: 1.5, sm: 2 },
  bgcolor: '#fff',
  color: '#0f172a',
  border: '1px solid rgba(15, 23, 42, 0.06)',
  borderRadius: { xs: '14px', sm: '16px' },
  boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
  '& .MuiTypography-body2': { fontSize: reportBodySx.fontSize, lineHeight: reportBodySx.lineHeight },
};

export const reportToggleSx = {
  '& .MuiToggleButton-root': {
    minHeight: 44,
    flex: { xs: 1, sm: 'initial' },
    px: { xs: 1, sm: 1.5 },
    color: '#334155',
    fontSize: '0.8rem',
    fontWeight: 700,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&.Mui-selected': {
      bgcolor: '#0f172a',
      color: '#fff',
      '&:hover': { bgcolor: '#1e293b' },
    },
    '&.Mui-focusVisible': { outline: '2px solid #2563eb', outlineOffset: 2, zIndex: 1 },
  },
};

export const reportPeriodControlSx = {
  alignSelf: 'center',
  flexShrink: 0,
  bgcolor: '#fff',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)',
  '& .MuiToggleButton-root': {
    ...reportToggleSx['& .MuiToggleButton-root'],
    minHeight: 0,
    flex: 'initial',
    minWidth: { xs: 34, sm: 42 },
    px: { xs: 0.75, sm: 1.25 },
    py: { xs: 0.35, sm: 0.45 },
    fontSize: { xs: '0.66rem', sm: '0.75rem' },
    borderColor: 'rgba(15, 23, 42, 0.08)',
  },
};

export const reportTableSx = {
  '& .MuiTableCell-root': { color: '#334155', fontVariantNumeric: 'tabular-nums' },
  '& .MuiTableCell-head': { bgcolor: '#f1f5f9', color: '#0f172a', fontWeight: 700 },
};
